import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ToasterPosition,
  ToasterService,
} from 'src/app/shared/services/toaster/toaster.service';
import { VoiceService } from './voice.service';
import { IDatatableColumn } from 'src/app/shared/datatable/datatable-column.interface';
import { AddVoiceComponent } from './add-voice/add-voice.component';
import { EditVoiceComponent } from './edit-voice/edit-voice.component';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { Subject, from } from 'rxjs';
import { CloneVoiceComponent } from './clone-voice/clone-voice.component';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { INavigator, NavigatorService } from 'src/app/shared/navigator';
import { PageEvent } from '@angular/material/paginator';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-voices',
  templateUrl: './voices.component.html',
  styleUrls: ['./voices.component.scss'],
})
export class VoicesComponent implements OnDestroy, OnInit {
  private _unsubscribe$ = new Subject<void>();
  columns: IDatatableColumn[] = [
    {
      name: 'Name',
      key: 'name',
      width: '10%',
      sortable: false,
      type: 'string',
    },
    {
      name: 'Id',
      key: '_id',
      width: '20%',
      sortable: false,
      type: 'string',
    },
    {
      name: 'Play Voice',
      key: 'url',
      width: '140px',
      sortable: false,
      type: 'music',
    },
    {
      name: 'Actions',
      key: 'actions',
      width: '40%',
      sortable: false,
      type: 'defaultTools',
    },
  ];

  constructor(
    public voiceService: VoiceService,
    private _modalService: NgbModal,
    public scroller: ViewportScroller,
    private _toast: ToasterService,
    private _navigatorService: NavigatorService,
  ) {}

  ngOnInit(): void {
    const paths: INavigator[] = [
      {
        path: '/',
        name: 'Home',
      },
      {
        path: '/lvl1/voices',
        name: 'Voices',
      },
    ];
    this._navigatorService.setNavigator(paths);
  }

  pageChangeEvent(event: PageEvent): void {
    this.voiceService.pageChangeEvent(event);
  }

  searchParamEvent(event: string): void {
    this.voiceService.setSearchParam(event);
  }

  addVoice(): void {
    this._modalService.open(AddVoiceComponent, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
  }

  editVoice(dataInput): void {
    const modalRef = this._modalService.open(EditVoiceComponent, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
    modalRef.componentInstance.voice = dataInput;
  }

  cloneVoice(dataInput): void {
    const modalRef = this._modalService.open(CloneVoiceComponent, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
    modalRef.componentInstance.voice = dataInput;
  }

  deleteVoice(dataInput): void {
    const query = {
      _id: dataInput['_id'],
      name: dataInput.name,
    };

    const modalRef = this._modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.text = `Are you sure about deleting ${dataInput.name}?`;
    from(modalRef.result)
      .pipe(
        filter((result: boolean) => result),
        takeUntil(this._unsubscribe$),
        switchMap(() => {
          return this.voiceService.deleteVoice(query);
        }),
      )
      .subscribe(
        (): void => {
          this._toast.showSuccess(
            'Voice deleted successfully',
            ToasterPosition.topRightSticky,
          );
        },
        (err): void => {
          console.log(err);
          this._toast.showError(
            err?.error?.message,
            ToasterPosition.topRightSticky,
          );
        },
      );
  }

  ngOnDestroy(): void {
    const scrollPosition = this.scroller.getScrollPosition();
    this.voiceService.setScrollPostion(scrollPosition);
    this.voiceService.setSelectedId(null);
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
